// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"248cd569","89":"ba3a5b9e","226":"33b45f84"}[chunkId] + ".chunk.css";
};